// Interactions for source-authored PDP sections. Existing variant handling owns
// availability, gallery changes and add-to-cart; links remain usable without JS.
document.addEventListener('click', async event => {
  const play = event.target.closest('[data-pdp-video-play]');
  if (play) {
    const video = play.closest('.pdp-video').querySelector('video');
    if (!video) return;
    try { await video.play(); play.hidden = true; }
    catch { video.controls = true; play.hidden = true; }
    return;
  }
  const choice = event.target.closest('[data-pdp-shade]');
  if (!choice || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const inputs = [...document.querySelectorAll('[data-product-section] [data-option-value]')];
  const input = inputs.find(input => input.closest('label')?.title === choice.dataset.pdpShade);
  if (!input) return; // Native variant link fallback.
  event.preventDefault();
  input.checked = true;
  input.dispatchEvent(new Event('change', { bubbles: true }));
  input.closest('[data-variant-options]').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
});
